import React from 'react';

import VpTableHeader from '../../components/VpTableHeader/VpTableHeader';
import { useFetchVideoCompilations } from '../../../hooks';

const headCells = [
  {
    id: 'enabled',
    label: 'Enabled',
    sortable: true
  },
  {
    id: 'title',
    label: 'Page Name',
    sortable: true
  },
  {
    id: 'campaign',
    label: 'Linked Campaign'
  },
  {
    id: 'link_clicks',
    label: 'Link Clicks',
    sortable: true
  },
  {
    id: 'created_at',
    label: 'Date Created',
    sortable: true
  },
  {
    id: 'lastReceived',
    label: 'Last Received Video'
  }
];

const VpVideoCompilationsTableHead = () => {
  const { data, refetch: refetchCompilations } = useFetchVideoCompilations();
  const meta = data?.recordMetadata;

  const handleSortChange = () => refetchCompilations();

  return <VpTableHeader onChange={handleSortChange} headCells={headCells} meta={meta} />;
};

export default VpVideoCompilationsTableHead;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/VpVideoCompilationsTableHead.jsx